import type { FaireProductEntity } from "../../entity_types/product";

export const p_gv3kb8c6wg: FaireProductEntity = {
  token: "p_gv3kb8c6wg",
  type: "product",
  name: "Natural Aromatherapy Essential Oil Shower Bombs Hand Crafted",
  brandToken: "b_35vnge4tj4",
  brandName: "Ani’s Market LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/b3d2206e4d821eec1b9e68e742ca360093a97491e99f8810e9412af3e29bfa33.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/108cbf7dc7f9330c1884f85b2002860294761ae89d7af567ec6d90c7886dd279.jpeg",
    "https://cdn.faire.com/fastly/3d8b9b8856b52fc9fc1612df66c0631a610077c0345deab674bc96a7308e1df3.jpeg",
    "https://cdn.faire.com/fastly/e78d1cb607437ef0ddf0a8ad4fa908cc2c046faa0bb7d434533791fb1623f65a.jpeg",
    "https://cdn.faire.com/fastly/c103e847ceae48578e8877fb289b2c82691b85c83c88935cb7964009e21d8b09.jpeg",
    "https://cdn.faire.com/fastly/78273a7201712272ce7c9abc010b8142f9d3bd9131ed77cb9bf410509db513f2.jpeg",
    "https://cdn.faire.com/fastly/892169d35cb957bb1b8274013108c5e1b696282825dd8340feea592111e12d3a.jpeg",
    "https://cdn.faire.com/fastly/577fe97bb88a7ed7a01be2ca44a3c149376c8ef758cd0982beeb96a6d881c313.jpeg",
    "https://cdn.faire.com/fastly/8201ad8a2ac01405f2cfdec14e83e1dd2551cdd9d45169cf5b6d3b83bdaa035e.jpeg",
    "https://cdn.faire.com/fastly/1b39374b5838e79377e604f3f49cf3b7f498712848d34ac2cfdd96ae042b1102.jpeg",
    "https://cdn.faire.com/fastly/2db4b551b294b0a92189d8495e1cacdd323cfb361095d4475825371a63e547dd.jpeg",
    "https://cdn.faire.com/fastly/db24da45ff9ed79439e634a7aec1f3a894a41b789d806e58bf9a372c2084a56e.jpeg",
    "https://cdn.faire.com/fastly/aa6b3b6ae3e4064d7622c170ee7e342500949dfbb3092ad793bb8f45200f47f9.jpeg",
  ],
  priceDollars: 4.57,
  description:
    "A bath bomb for your shower!\nBest-selling aromatherapy shower steamers! \n- SINUS RELIEF - our best seller! Made with a high concentration of peppermint, eucalyptus, tea tree oils and menthol crystals! This one will keep your customers coming back for more!\n- AWAKE: sweet orange & grapefruit\n- RELAX: lavender & bergamot\n- REFRESH: lemon & mint\n- HAPPY: ylang ylang, vanilla, sweet orange & lemon\n- RENEW: lemongrass\n- DE-STRESS: tangerine & ginger\n- MAN CAVE: sandalwood & lime\n- HEADACHE BUSTER\n\nDisplay boxes also available - check brand page to view. \n\nOur shower steamers are all natural, made with no artificial fragrances or colors, hand crafted in our Clarksville, TN location. If you have any questions don't hesitate to reach out.\n\n\nTags: gifts scented body beauty candle soap spa massage made in USA woman Christmas holiday stocking stuffer natural organic handmade bath bomb unique aromatherapy high women festive fall winter hostess best selling shipping colorful steamer individual bulk",
  tags: [],
  msrpDollars: 9.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:11.095Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
